import React from 'react'

const Refractions = () => {
  return (
    <div>Refractions</div>
  )
}

export default Refractions